import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AutocompleteOption } from '@breathelife/ui-components';
import { FieldTypes } from '@zinnia/form-engine-sdk';

import { getValidationOptionsByFieldType } from '../../../../../../Helpers/questionnaireEditor/selectOptions';

export function useGetValidationOptions(fieldType: FieldTypes): AutocompleteOption[] {
  const { t } = useTranslation();

  const validationOptions = useMemo(() => getValidationOptionsByFieldType(t)[fieldType], [t, fieldType]);

  return validationOptions;
}
